<template>
  <div class="database-container">
    <a-card class="content-card">
      <div class="page-header">
        <div class="header-icon">
          <a-icon type="qrcode" />
        </div>
        <div class="header-text">
          <h2 class="page-title">{{ translate('qrcode.title') }}</h2>
          <p class="page-description">{{ translate('qrcode.description') }}</p>
        </div>
      </div>
      
      <div class="qrcode-content">
        <div class="form-section">
          <div class="form-card">
            <div class="form-title">
              <a-icon type="edit" />
              <span>{{ translate('qrcode.input_config') }}</span>
            </div>
            
            <div class="form-row">
              <div class="form-item">
                <label class="form-label">
                  <a-icon type="appstore" /> {{ translate('qrcode.protocol_type') }}
                </label>
                <a-select
                  v-model="Selectvalue"
                  class="form-select"
                  :placeholder="translate('qrcode.placeholder1')"
                  @change="handleChange"
                >
                  <a-select-option v-for="item in options" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </a-select-option>
                </a-select>
              </div>
              
              <div class="form-item flex-1">
                <label class="form-label">
                  <a-icon type="link" /> {{ translate('qrcode.connection_info') }}
                </label>
                <a-input
                  class="form-input"
                  v-model="inputValue"
                  @change="onChange"
                  :placeholder="translate('qrcode.placeholder2')"
                />
              </div>
              
              <div class="form-item">
                <label class="form-label">&nbsp;</label>
                <a-button type="primary" class="action-btn" @click="getQrCode">
                  <a-icon type="scan" /> {{ translate('qrcode.generate') }}
                </a-button>
              </div>
            </div>
          </div>
        </div>

        <div class="qrcode-section">
          <div class="qrcode-card" :class="{ 'has-qrcode': clickValue }">
            <div class="qrcode-header">
              <a-icon type="scan" />
              <span>{{ translate('qrcode.result_title') }}</span>
            </div>
            
            <div class="qrcode-display">
              <div v-if="!clickValue" class="placeholder">
                <div class="placeholder-icon">
                  <a-icon type="qrcode" />
                </div>
                <p class="placeholder-text">{{ translate('qrcode.placeholder3') }}</p>
                <p class="placeholder-hint">{{ translate('qrcode.placeholder4') }}</p>
              </div>
              <div v-else class="qrcode-result">
                <div class="qrcode-wrapper">
                  <qrcode-vue :value="clickValue" :size="size" level="L" class="qrcode-img" />
                </div>
                <div class="qrcode-info">
                  <div class="info-item">
                    <span class="info-label">{{ translate('qrcode.protocol_type') }}</span>
                    <span class="info-value">{{ Selectvalue === 'shadowrocket' ? 'Shadowrocket' : 'Socks5' }}</span>
                  </div>
                  <div class="info-item">
                    <span class="info-label">{{ translate('qrcode.connection_info') }}</span>
                    <span class="info-value">{{ maskConnectionInfo(inputValue) }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-card>
  </div>
</template>

<script>
import QrcodeVue from 'qrcode-vue';

export default {
  name: "QRCodeGenerator",
  components: {
    QrcodeVue
  },
  inject: ['languageState'],
  computed: {
    currentLanguage() {
      return this.languageState?.languageCode || 'zh';
    }
  },
  data() {
    return {
      inputValue: "",
      clickValue: "",
      size: 200,
      Selectvalue: 'shadowrocket',
      options: [
        { label: 'Shadowrocket', value: 'shadowrocket' },
        { label: 'Socks5', value: 'socks5' }
      ]
    };
  },
  methods: {
    translate(key) {
      const lang = this.currentLanguage;
      const dict = {
        'qrcode.title': lang === 'zh' ? '二维码生成' : 'QR Code Generator',
        'qrcode.description': lang === 'zh' ? '将代理连接信息转换为二维码，使用扫一扫快速添加代理' : 'Convert proxy connection information to QR code, use scan to quickly add proxy',
        'qrcode.input_config': lang === 'zh' ? '输入配置' : 'Input Configuration',
        'qrcode.protocol_type': lang === 'zh' ? '协议类型' : 'Protocol Type',
        'qrcode.connection_info': lang === 'zh' ? '连接信息' : 'Connection Information',
        'qrcode.generate': lang === 'zh' ? '生成二维码' : 'Generate QR Code',
        'qrcode.result_title': lang === 'zh' ? '二维码结果' : 'QR Code Result',
        'qrcode.placeholder1': lang === 'zh' ? '请选择协议类型' : 'Please select protocol type',
        'qrcode.placeholder2': lang === 'zh' ? '例如: username:password@ip:port' : 'Example: username:password@ip:port',
        'qrcode.placeholder3': lang === 'zh' ? '请先输入连接信息并点击"生成二维码"' : 'Please enter connection information and click "Generate QR Code"',
        'qrcode.placeholder4': lang === 'zh' ? '支持 Shadowrocket 和 Socks5 协议' : 'Supports Shadowrocket and Socks5 protocols',
        'qrcode.please_enter_info': lang === 'zh' ? '请输入连接信息' : 'Please enter connection information',
        'qrcode.encoding_failed': lang === 'zh' ? '编码失败，请检查输入格式' : 'Encoding failed, please check input format',
        'qrcode.incorrect_format': lang === 'zh' ? '输入格式不正确，请使用 "IP:端口:账号:密码" 格式' : 'Incorrect input format, please use "IP:Port:Username:Password" format'
      };
      return dict[key] || key;
    },
    maskConnectionInfo(info) {
      if (!info) return '-';
      if (info.includes('@')) {
        return info;
      }
      const parts = info.split(':');
      if (parts.length >= 4) {
        return `${parts[0]}:****@${parts[0]}:${parts[1]}`;
      }
      return info;
    },
    getQrCode() {
      if (this.inputValue === '') {
        this.$message.error(this.translate('qrcode.please_enter_info'));
        return;
      }
      
      let url_head = 'socks://';
      let codeInfo;

      if (this.inputValue.includes("@")) {
        if (this.Selectvalue === 'shadowrocket') {
          try {
            this.clickValue = url_head + btoa(unescape(encodeURIComponent(this.inputValue)));
          } catch (e) {
            console.error('Base64 编码失败:', e);
            this.$message.error(this.translate('qrcode.encoding_failed'));
          }
        } else if (this.Selectvalue === 'socks5') {
          this.clickValue = url_head + this.inputValue;
        }
      } else {
        const parts = this.inputValue.split(":");
        if (parts.length < 4) {
          this.$message.error(this.translate('qrcode.incorrect_format'));
          return;
        }
        codeInfo = `${parts[2]}:${parts[3]}@${parts[0]}:${parts[1]}`;
        if (this.Selectvalue === 'shadowrocket') {
          try {
            this.clickValue = url_head + btoa(unescape(encodeURIComponent(codeInfo)));
          } catch (e) {
            console.error('Base64 编码失败:', e);
            this.$message.error(this.translate('qrcode.encoding_failed'));
          }
        } else if (this.Selectvalue === 'socks5') {
          this.clickValue = url_head + codeInfo;
        }
      }
    },
    onChange(e) {
      this.inputValue = e.target.value;
    },
    handleChange(value) {
      this.Selectvalue = value;
    }
  }
};
</script>

<style lang="less" scoped>
.database-container {
  padding: 24px;
  background: linear-gradient(180deg, #f0f5ff 0%, #f5f5f5 100%);
  min-height: 100%;
}

.content-card {
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  background: #fff;
  border: 1px solid #e8e8e8;
  padding: 0;
  overflow: hidden;
}

.page-header {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 28px 32px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  margin: 0;
  border-bottom: none;
}

.header-icon {
  width: 56px;
  height: 56px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .anticon {
    font-size: 28px;
    color: #fff;
  }
}

.header-text {
  flex: 1;
}

.page-title {
  font-size: 26px;
  font-weight: 700;
  color: #fff;
  margin: 0 0 6px 0;
  letter-spacing: 0.5px;
}

.page-description {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0;
  line-height: 1.6;
}

.qrcode-content {
  padding: 32px;
}

.form-section {
  margin-bottom: 32px;
}

.form-card {
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
}

.form-title {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 24px;
  padding-bottom: 20px;
  border-bottom: 1px solid #f0f0f0;
  
  .anticon {
    color: #667eea;
    font-size: 20px;
  }
}

.form-row {
  display: flex;
  align-items: flex-start;
  gap: 24px;
  flex-wrap: wrap;
}

.form-item {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  
  &.flex-1 {
    flex: 1;
    min-width: 240px;
  }
}

.form-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 600;
  color: #434343;
  margin-bottom: 12px;
  line-height: 1.5;
  
  .anticon {
    color: #667eea;
    font-size: 16px;
  }
}

.form-select {
  width: 200px;
  
  :deep(.ant-select-selector) {
    border-radius: 10px !important;
    height: 48px !important;
    
    .ant-select-selection-item {
      line-height: 46px !important;
      font-size: 15px;
    }
  }
}

.form-input {
  width: 100%;
  border-radius: 10px !important;
  height: 48px;
  font-size: 15px;
  
  &:focus,
  &:hover {
    border-color: #667eea !important;
    box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2) !important;
  }
}

.action-btn {
  height: 48px;
  font-size: 15px;
  font-weight: 600;
  padding: 0 28px;
  border-radius: 10px !important;
  line-height: 48px !important;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
  border: none !important;
  letter-spacing: 0.5px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  
  .anticon {
    font-size: 16px;
  }
  
  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(102, 126, 234, 0.4) !important;
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%) !important;
  }
  
  &:active {
    transform: translateY(0);
  }
}

.qrcode-section {
  margin-top: 0;
}

.qrcode-card {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  border: 1px solid #f0f0f0;
  transition: all 0.3s ease;
  
  &.has-qrcode {
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
    border-color: rgba(102, 126, 234, 0.3);
  }
}

.qrcode-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 18px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4e8eb 100%);
  border-bottom: 1px solid #f0f0f0;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  
  .anticon {
    color: #667eea;
  }
}

.qrcode-display {
  padding: 40px;
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  text-align: center;
  padding: 40px;
  
  .placeholder-icon {
    width: 80px;
    height: 80px;
    margin: 0 auto 20px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8ebf0 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    
    .anticon {
      font-size: 40px;
      color: #ccc;
    }
  }
  
  .placeholder-text {
    font-size: 15px;
    color: #666;
    margin-bottom: 8px;
  }
  
  .placeholder-hint {
    font-size: 13px;
    color: #999;
  }
}

.qrcode-result {
  display: flex;
  align-items: center;
  gap: 40px;
  flex-wrap: wrap;
  justify-content: center;
}

.qrcode-wrapper {
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.15);
  border: 2px solid #667eea;
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.02);
    box-shadow: 0 8px 30px rgba(102, 126, 234, 0.25);
  }
  
  .qrcode-img {
    display: block;
  }
}

.qrcode-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 200px;
}

.info-item {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8ebf0 100%);
  border-radius: 10px;
}

.info-label {
  font-size: 12px;
  color: #999;
  font-weight: 500;
}

.info-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  word-break: break-all;
}

@media (max-width: 768px) {
  .database-container {
    padding: 16px;
  }
  
  .page-header {
    padding: 20px 24px;
    flex-direction: column;
    text-align: center;
    gap: 12px;
  }
  
  .header-icon {
    width: 48px;
    height: 48px;
    
    .anticon {
      font-size: 24px;
    }
  }
  
  .page-title {
    font-size: 22px;
  }
  
  .qrcode-content {
    padding: 20px;
  }
  
  .form-row {
    flex-direction: column;
    gap: 16px;
  }
  
  .form-item,
  .form-item.flex-1 {
    width: 100%;
  }
  
  .form-select {
    width: 100%;
  }
  
  .action-btn {
    width: 100%;
  }
  
  .qrcode-display {
    padding: 24px;
  }
  
  .qrcode-result {
    flex-direction: column;
    gap: 24px;
  }
  
  .qrcode-wrapper {
    padding: 16px;
    
    :deep(canvas) {
      max-width: 100%;
      height: auto !important;
    }
  }
}
</style>
